module.exports = __webpack_public_path__ + "img/1562932230.614782cd.jpg";